export const classes = {
  adornment: 'mr-4 place-center gap-2',
};
